"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getGlobal = _interopRequireDefault(require("../../utils/getGlobal"));

var _default = function _default() {
  var global = (0, _getGlobal.default)();
  var pbjs = global.pbjs || {}; // We're not running in global scope, so make sure to
  // assign to the global.

  if (!global.pbjs) {
    global.pbjs = pbjs;
  }

  pbjs.que = pbjs.que || [];
  return pbjs;
};

exports.default = _default;